module.exports = __webpack_public_path__ + "static/layout_image_2-035c0537a23b972a159a078193d97624.png";